import React from 'react';
import * as Styles from './style';
import { P } from 'components/reusable-css';

const WhNetworks = ({ data }) => {
  return (
    <Styles.Network>
      <Styles.FlexColumn>
        <Styles.Flexx>
          <P>{data.ipv4}</P>
        </Styles.Flexx>
      </Styles.FlexColumn>
      <Styles.FlexColumn>
        <P className="network-border">{data.ipv6}</P>
      </Styles.FlexColumn>
    </Styles.Network>
  );
};

export { WhNetworks };
